import React from 'react';
import classNames from 'classnames';
import { oneOf } from 'prop-types';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { buildImageURL } from '../../../utils/product-add-on-utils';
import { ICONS } from '../../../utils/product-add-on-constants';

const SAMDualPathTooltip = React.forwardRef(({ channel }, buttonRef) => {

  const toolTipLabelClasses = classNames('&__schedule-a-measure-tooltip', {
    'u__default-link': true,
    'product-add-on-tooltip-content__label': true,
    scrollTouch: channel === 'mobile',
  });

  const tooltipContent = (
    <div className="product-add-on-tooltip-content" data-channel={`${channel}`}>
      <div className="product-add-on-tooltip-content__header">How it Works</div>
      <ul className="product-add-on-tooltip-content__list">
        <li>First, schedule your measure appointment online. We’ll
          come to your home to take precise digital measurements
          and make note of any special installation requirements.
        </li>
        <li>Based on these measurements and the specific flooring
          you choose, we’ll provide a project quote covering materials
          and installation.
        </li>
        <li>Once your purchase is complete, our local, licensed
          installers will contact you to schedule a convenient installation date.
        </li>
      </ul>
    </div>
  );

  return (
    <Tooltip channel={channel} placement="bottom" content={tooltipContent} closeButton>
      <button type="button" className={toolTipLabelClasses} ref={buttonRef}>
        What to Expect
        <img
          src={buildImageURL(ICONS.info)}
          alt="information tooltip"
          className="product-add-on-tooltip-content__label__suffix"
        />
      </button>
    </Tooltip>
  );
});

SAMDualPathTooltip.displayName = 'ProductAddOns-SAM-dualPath-tooltip';

SAMDualPathTooltip.propTypes = {
  /** What view to render ['desktop' || 'mobile']  */
  channel: oneOf(['desktop', 'mobile']),
};

SAMDualPathTooltip.defaultProps = {
  channel: 'desktop',
};

export { SAMDualPathTooltip };